import {HitDetectorWidgetIntervalType, NodeSummaryWidgetIntervalType} from './enums';

/*
    Список типов HitDetectorWidgetIntervalType
*/

export const hitDetectorWidgetIntervalTypes: {
  type: HitDetectorWidgetIntervalType;
  name: string;
}[] = [
  {
    type: HitDetectorWidgetIntervalType.Days,
    name: 'Дни',
  },
  {
    type: HitDetectorWidgetIntervalType.Hours,
    name: 'Часы',
  },
];

/*
    Список типов NodeSummaryWidgetIntervalType
*/

export const nodeSummaryWidgetIntervalTypes: {
  type: NodeSummaryWidgetIntervalType;
  name: string;
}[] = [
  {
    type: NodeSummaryWidgetIntervalType.Day,
    name: 'Последний день',
  },
  {
    type: NodeSummaryWidgetIntervalType.Week,
    name: 'Последняя неделя',
  },
  {
    type: NodeSummaryWidgetIntervalType.Month,
    name: 'Последний месяц',
  },
];
